// Zombie override (MOB special). PURE (ENG-1).
//
// Standard melee behaviour plus daylight burning: exposed to full sky light
// during the day (and not in water/shade) it catches fire (LIT sky check).
import { TICK } from '../../config';
import type { MobDef } from '../../registry/schemas';
import { halfOf, type Entity, type MobContext } from '../entity';
import { meleeAI } from '../archetypes/melee';

/** Fire ticks applied while a zombie stands in daylight (re-armed each exposed tick). */
const BURN_TICKS = 160;

export function zombie(e: Entity, def: MobDef, ctx: MobContext): void {
  meleeAI(e, def, ctx);
  if (!def.burnsInSunlight) return;

  const day = ctx.frame.dayTime % TICK.DAY_TICKS < TICK.DAY_TICKS / 2;
  const head = Math.floor(e.y + halfOf(e, def)); // sample near the head
  const exposed = ctx.world.getSkyLight(Math.floor(e.x), Math.floor(e.y + 1.6), Math.floor(e.z)) === 15;
  const wet = ctx.world.isFluid(Math.floor(e.x), head, Math.floor(e.z));
  if (day && exposed && !wet) e.fire = Math.max(e.fire, BURN_TICKS);
}
